"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeFlowReducer = changeFlowReducer;
var _action_types = require("../../constants/action_types");
var _defaultState = require("./defaultState");
function changeFlowReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaultState.defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _action_types.FLOW_CHANGE_FLOW_TYPE:
      return action.flow;
  }
  return state;
}